<ng-container *ngIf="showModal">
  <h3 class="bold" mat-dialog-title>{{ data.title }}</h3>

  <mat-dialog-content>
    {{ data.subText }}
  </mat-dialog-content>
  <mat-dialog-actions>
    <button
      class="cancelBtn"
      type="button"
      readonly="readonly"
      (click)="onClick()"
    >
      {{ data.cancelBtnName }}
    </button>
    <button
      [ngClass]="['submitBtn', data.submitBtnClass ? data.submitBtnClass : '']"
      type="button"
      readonly="readonly"
      (click)="onClick('ok')"
    >
      {{ data.submitBtnName }}
    </button>
  </mat-dialog-actions>
</ng-container>
